/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';

import { Swimlane } from 'src/app/app-data/models/Swimlane';

import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { SwimlaneList } from 'src/app/common/fancy-firebase-ticket/lists/SwimlaneList';

//decide how to implement the generic of this
// - the action calling side
// - the action handling side in the firebase list
// - List vs Object

// Action builder side:
// - for each type, need a function that accepts something to identify the list item(s) and arbitrary data to be used/ forwarded
// - that function will create the action and push it onto the list
//
// Action handling side:
// - need to handle a thing in various way depending on the type of that thing
// - want default handling of that thing that can be overriden by the children for specific types

// type CombinedType = AddItemAction | RemoveItemAction | LocalUpdateAction;
//
// interface AddItemAction extends FancyAction{}
// interface RemoveItemAction extends FancyAction{}
// interface LocalUpdateAction extends FancyAction{}

export class Swimlanes extends FancyActionableFirebase<Swimlane, FancyAction, SwimlaneList> {
	constructor(public data: SwimlaneList) {
		super(data);
	}
}
